export const JOIN_APPLICATION = "emailRecipient.joinApplication"
export const DONATION_APPLICATION = "emailRecipient.donationApplication"
export const ASSISTANCE_APPLICATION = "emailRecipient.assistanceApplication"
export const UPGRADE_APPLICATION = "emailRecipient.upgradeApplication"
export const FEEDBACK = "emailRecipient.feedback"
